export default __webpack_public_path__ + "static/media/Comuni logo.b341358e.png";